import config from 'config';
import useAppStore from '../../useAppStore';

const LOGIN = 'game/auth/LOGIN';
const LOGIN_SUCCESS = 'game/auth/LOGIN_SUCCESS';
const LOGIN_FAIL = 'game/auth/LOGIN_FAIL';
const LOAD = 'game/auth/LOAD';
export const LOAD_SUCCESS = 'game/auth/LOAD_SUCCESS';
const LOAD_FAIL = 'game/auth/LOAD_FAIL';
export const LOGOUT = 'game/auth/LOGOUT';
const LOGOUT_SUCCESS = 'game/auth/LOGOUT_SUCCESS';
const LOGOUT_FAIL = 'game/auth/LOGOUT_FAIL';
const SET_MONEY_BUTTON_USER_ID_HASH = 'game/auth/SET_MONEY_BUTTON_USER_ID_HASH';
const SET_NICKNAME = 'set/nickname';
const SET_AVATAR = 'set/avatar';

const initialState = {
  loaded: false,
  user: null,
  moneyButtonUserIdHash: null,
};

export default function info(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS:
      useAppStore.getState().setUserData(action.result);
      return {
        ...state,
        loaded: true,
        user: action.result,
      };
    case LOAD_FAIL:
      return {
        ...state,
        loaded: true,
      };
    case LOGOUT:
      useAppStore.getState().setSelectedAsset('BSV');
      return { ...initialState, loaded: true };
    case SET_NICKNAME:
      return { ...state, user: { ...state.user, nickname: action.nickname } };
    case SET_AVATAR:
      return {
        ...state,
        user: { ...state.user, profile_image: action.newUrl },
      };
    default:
      return state;
  }
}
export function login(provider) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: async ({ client }) => client.get(`/auth/v2/${provider}/login`),
  };
}
export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: async ({ client }) => {
      const { data } = await client.get('/auth/v2/me');
      return data;
    },
  };
}
export function logout() {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: async ({ client }) => client.post('/auth/v2/logout'),
  };
}

export function setNickname(nickname) {
  return {
    type: SET_NICKNAME,
    nickname,
  };
}
export function setAvatar(newUrl) {
  return {
    type: SET_AVATAR,
    newUrl,
  };
}
export function setMoneyButtonUserIdHash(moneyButtonUserIdHash) {
  return {
    type: SET_MONEY_BUTTON_USER_ID_HASH,
    moneyButtonUserIdHash,
  };
}

export function getLoginUrl(provider) {
  return `https://${config.apiHost}/auth/v2/${provider}/login?redirectUrl=${document.URL}`;
}
